/* eslint-disable no-param-reassign */
import React, { useContext, useRef } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import Icon, { ICONS, COLORS } from '../../general-components/icon';
import { cleanupVideoStreamElement } from '../../../utils/video/video-streams';
import { GreenroomState as GS } from '../../../stores/types/types';
import { AVContext } from '../../../contexts/audio-video';

interface OwnProps {
	onVideoConnected?: Function
}

export default function AppEntryVideoView(props: OwnProps) {
	const mainVideoStream = useSelector((s: GS) => s.VideoReducer.mainVideoStream);
	const videoElement = useRef<HTMLVideoElement | null>(null);

	const { getAV, setAV } = useContext(AVContext);
	const av = getAV('local');
	const { audio: hasAudio, video: hasVideo } = av;

	const toggleVideoMuted = () => setAV({ ...av, video: !hasVideo });
	const toggleAudioMuted = () => setAV({ ...av, audio: !hasAudio });

	return (
		<div className="app-entry-video-wrapper-outer">
			<div className="app-entry-video-wrapper">
				<div className="app-entry-video-container">
					<div className="app-entry-video-container-wrapper">
						<video
							autoPlay
							playsInline
							style={{ transform: 'scaleX(-1)', display: hasVideo ? 'block' : 'none' }}
							ref={(ref) => {
								if (ref && ref.srcObject !== mainVideoStream) {
									try {
										ref.srcObject = mainVideoStream;
										ref.volume = 0;
										ref.play().catch((e) => console.error(e));
										videoElement.current = ref;
										cleanupVideoStreamElement(ref);
										props.onVideoConnected?.();
									} catch (e) {
										console.error(e);
									}
								}
							}}>
						</video>
					</div>

					<div className="controls">
						<div>
							<button onClick={toggleVideoMuted} className={classNames('bottom-circle-btn', { muted: !hasVideo })}>
								<Icon
								name={hasVideo ? ICONS.CAMERA_ON : ICONS.CAMERA_OFF}
								size={19}
								color={COLORS.WHITE} />
							</button>
							<button onClick={toggleAudioMuted} className={classNames('bottom-circle-btn', { muted: !hasAudio })}>
								<Icon
									name={hasAudio ? ICONS.MICROPHONE_ON : ICONS.MICROPHONE_OFF }
									size={19}
									color={COLORS.WHITE} />
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
